import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { KeyWordDto } from "src/app/models/scientific-archive-document-dto";
import { LABELS } from "../scientific-archive-document-details.constants";
import { Observable } from "rxjs";

@Component({
    selector: 'app-scientific-archive-document-keywords',
    templateUrl: './scientific-archive-document-keywords.component.html',
    styleUrls: ['./scientific-archive-document-keywords.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScientificArchiveDocumentKeywordsComponent {
    @Input() keywords: KeyWordDto[] | undefined;
    @Input() currentLanguage!: Observable<string>;
    LABELS = LABELS;

    constructor() {}

}